import { Modal } from "@xola/ui-kit";
import React from "react";
import { PaymentLineItem, StripeBillingDetails } from "types";
import { CreditCardIcon } from "@/components/Common/CreditCardIcon";
import { Currency } from "@/components/Common/Currency";
import { SecondaryButton } from "@/components/Common/SecondaryButton";

interface DisputeSelectModalProps {
    isOpen: boolean;
    disputedLineItems: PaymentLineItem[];
    onSelect: (lineItem: PaymentLineItem) => void;
    onClose: () => void;
}

export const DisputeSelectModal = ({ isOpen, disputedLineItems, onSelect, onClose }: DisputeSelectModalProps) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            {isOpen && (
                <DisputeSelectModalContent
                    disputedLineItems={disputedLineItems}
                    onSelect={onSelect}
                    onClose={onClose}
                />
            )}
        </Modal>
    );
};

interface DisputeSelectModalContentProps {
    disputedLineItems: PaymentLineItem[];
    onSelect: (lineItem: PaymentLineItem) => void;
    onClose: () => void;
}

const DisputeSelectModalContent = ({ disputedLineItems, onSelect, onClose }: DisputeSelectModalContentProps) => {
    return (
        <>
            <Modal.Header description="Please select one of the disputes to proceed">
                Multiple Disputed Payments
            </Modal.Header>
            <Modal.Body>
                <div className="space-y-3">
                    {disputedLineItems.map((lineItem) => {
                        const cardSummary = lineItem.payment?.meta?.cardSummary;
                        const billingDetails = lineItem.payment?.billingDetails as StripeBillingDetails | undefined;
                        const brand = cardSummary?.brand;
                        const last4 = cardSummary?.last4 ?? lineItem.payment?.last4;
                        const name = cardSummary?.name ?? billingDetails?.name;

                        return (
                            <button
                                key={lineItem.id}
                                type="button"
                                className="flex w-full cursor-pointer items-center justify-between rounded-lg border border-gray-lighter p-4 hover:bg-primary-lighter"
                                onClick={() => onSelect(lineItem)}
                            >
                                <div className="text-md font-bold">
                                    <Currency>{Math.abs(lineItem.amount)}</Currency>
                                </div>
                                <div className="no-translate flex items-center space-x-2 text-right">
                                    <div>
                                        {name && (
                                            <div className="font-semibold">
                                                <var data-var="cardholderName">{name}</var>
                                            </div>
                                        )}
                                        {brand && last4 && (
                                            <div className="flex items-center justify-end space-x-1 text-sm text-gray-darker">
                                                <CreditCardIcon name={brand} size="small" />
                                                <span className="font-semibold">
                                                    •••• <var data-var="lastFourDigits">{last4}</var>
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </button>
                        );
                    })}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
            </Modal.Footer>
        </>
    );
};
